import PropTypes from 'prop-types';
import React from 'react';
import { HeadingArticle } from '../design-system/Headings';

export default function LockedContent({ locked, children }) {
  if (!locked) return children;

  return (
    <div className="ss_locked-content">
      <span className="ss_locked-content__text">
        <HeadingArticle el="span">Locked</HeadingArticle>
      </span>
      <div className="ss_locked-content__body">{children}</div>
    </div>
  );
}

LockedContent.propTypes = {
  children: PropTypes.node.isRequired,
  locked: PropTypes.bool.isRequired,
};
